







































































import { Component, Mixins } from 'vue-property-decorator'
import GlobalMixin, {ALERT_TYPE} from '@/mixins/globalMixin'
import LoadingComponent from '@/components/LoadingComponent.vue'
import AlertBarComponent from '@/components/AlertBarComponent.vue'
import BreadcrumbsComponent from '@/components/BreadcrumbsComponent.vue'
import SelectDaysComponent from '@/components/SelectDaysComponent.vue'
import CustomerSelectDialogComponent from '@/components/CustomerSelectDialogComponent.vue'
import DateAndUserPickerDialogComponent from '@/components/DateAndUserPickerDialogComponent.vue'
import PdfViewComponent from '@/components/PdfViewComponent.vue'
import { Report } from '@/domain/Report'
import CsvResponse from '@/domain/CsvResponse'
import ReportsService, { SerchConditon } from '@/service/ReportsService'
import CsvResponsesService from '@/service/CsvResponsesService'

@Component({
  components: {
    LoadingComponent,
    AlertBarComponent,
    BreadcrumbsComponent,
    SelectDaysComponent,
    CustomerSelectDialogComponent,
    DateAndUserPickerDialogComponent,
    PdfViewComponent,
  },
})
export default class MemberReportCsvExport extends Mixins(GlobalMixin) {
  reportsService = ReportsService.instance
  csvResponsesService = CsvResponsesService.instance

  /** 検索条件 */
  conditions = new SerchConditon({isCsvOnly: true})
  /** データテーブル ヘッダー設定 */
  headers = [
          { text: "NDFP検査依頼ID", value: "requestId", width: "160px" },
          { text: "報告日", value: "reportOn", width: "100px" },
          { text: "受付番号", value: "requestNo", width: "130px" },
          { text: "顧客名", value: "customerInfo.customerName", width: "240px" },
          { text: "検体名", value: "specimenName", width: "180px" },
          { text: "検査名称", value: "inspectionNames" },
  ]
  list: Report[] = []
  selectItems: Report[] = []
  errors: string[] = []

  /**
   * 選択リストのバリデーション
   */
  get isValidate() {
    return this.selectItems.length !== 0
  }

  /**
   * 初期実行
   */
  mounted() {
    /* 初期検索 */  
    this.search()
  }

  /**
   * 検索処理
   */
  search() {
    this.showLoading()
    this.reportsService.findAll(this.conditions)
      .then(x => {
        this.list = x
        this.selectItems = []
        this.hideLoading()
      })
      .catch(error => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("検索エラー", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }

  /**
   * 報告作業ファイルのエクスポート
   */
  onCsvExport() {
    const reportNos = this.selectItems.map(x => x.reportNo)
    this.showLoading()
    this.csvResponsesService.download(reportNos)
      .then((x) => {
        const fileName = "FromBVI" + this.dateTimeUtils.format("yyMMdd_HHmm_status7.csv")
        const header = CsvResponse.getHeader().join(",")
        const csvDataStatus7 = x
            .map(y => y.toCsv(","))
            .reduce((p, y) => p + "\r\n" + y, header)
        const status7File = this.convertFile(fileName, "text/csv", csvDataStatus7)
        this.hideLoading()
        this.download(status7File)
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("取得に失敗しました", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }

  /**
   * 報告ファイルのダウンロード
   */
  onCsvDownload() {
    this.errors = []
    const reportNos = this.selectItems.map(x => x.reportNo)
    this.showLoading()
    this.csvResponsesService.download(reportNos)
      .then((csvResponses) => {
        csvResponses.forEach(x => {
          const rowErrors = x.validate()
          rowErrors.forEach(e => this.errors.push(`${x.requestId} : ${e}`))
        })
        if (this.errors.length === 0) {
          const fileName = "FromBVI" + this.dateTimeUtils.format("yyMMdd_HHmm.csv")
          const header = CsvResponse.getHeader().join("|")
          const csvDataStatus7 = csvResponses
              .map(x => x.toCsv("|"))
              .reduce((p, x) => p + "\r\n" + x, header)
          const status7File = this.convertFile(fileName, "text/csv", csvDataStatus7)
          this.download(status7File)

          /* 報告書ファイルダウンロード */
          this.selectItems.forEach(report => {
            const filenames = csvResponses.filter(x => x.requestId === report.requestId).map(x => `${x.requestId}_${x.reportNo}.pdf`)
            if (filenames.length === 1) {
              const filename = filenames[0]
              this.reportsService.download(report.reportNo)
                  .then(reportFile => {
                    reportFile.filename = filename
                    this.download(reportFile)
                  })
            }
          })
        }
        this.hideLoading()
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("取得に失敗しました", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }
}
